import "./dom_extend";

import "./module_loader";
import "./modules/google_recaptcha";

// Recaptcha je javascriptová knihovna od Google, kterou je potřeba
// nejprve načíst. Vzhledem k její velikosti ji načítáme pouze
// na stránkách, na kterých je nějaký recaptchou ošetřený formulář.
var isRecaptchaLoaded = false;
var isRecatpchaRequested = false;
var isRecaptchaError = false;


function recaptchaCallback(form, recaptchaWidgetId, token) {
	if (form.getAttribute("data-remote")) {
		// Pro ajaxový formulář odešleme pouze zprávu, že má být odeslán.
		form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
	}
	else {
		// Neajaxový formulář jednoduše odešleme.
		form.submit();
	}
}

//
// Spustí na formuláři recaptchu.
//
function executeRecaptcha(event, form, recaptchaWidgetId) {
	form.classList.add("sending-request");
	event.preventDefault();

	if (isRecaptchaError) {
		isRecaptchaError = false;
		window.grecaptcha.reset(recaptchaWidgetId);
	}
	else {
		// Zresetujeme nakonec i v případě, že error nenastal.
		// Kód tu pro jistotu necháme takto divně (obě větve podmínky skončí stejně),
		// abychom v případě, že to nebude fungovat, mohli chování vrátit nazpět.
		window.grecaptcha.reset(recaptchaWidgetId);
	}

	window.grecaptcha.execute(recaptchaWidgetId);
}

//
// Po úspěšném odeslání formuláře je zapotřebí provést "reset" recaptchy.
// Recaptcha zdá se neumí opakované požadavky, ale je zapotřebí provést vždy
// nové ohodnocení uživatele.
//
function resetRecaptcha(event, form, recaptchaWidgetId) {
	window.grecaptcha.reset(recaptchaWidgetId);
}

//
// Uklidí po recaptche (v případě chyby).
//
function cleanRecaptcha(form) {
	form.classList.remove("sending-request");
}

//
// Vyrenderujeme do formuláře kód recaptchy.
// Předpokládáme, že formulář nemá recaptchu aktivovanou.
//
function activateRecaptchaOnForm(form) {
	// Kontejner pro recaptchu.
	var container = form.querySelector("[data-sitekey]");

	// Samotná recaptcha.
	var recaptchaWidgetId = window.grecaptcha.render(container, {
		sitekey: container.getAttribute("data-sitekey"),
		callback: function(token) {
			// console.log("Recaptcha Widget #" + recaptchaWidgetId + ": callback");
			recaptchaCallback(form, recaptchaWidgetId, token);
		},
		"expired-callback": function() {
			// console.log("Recaptcha Widget #" + recaptchaWidgetId + ": expired");
			isRecaptchaError = true;
			cleanRecaptcha(form);
		},
		"error-callback": function() {
			// console.log("Recaptcha Widget #" + recaptchaWidgetId + ": error");
			isRecaptchaError = true;
			cleanRecaptcha(form);
		},
		size: "invisible"
	});

	// Kliknutí na tlačítko submit spustí recaptchu.
	var submitButtons = form.querySelectorAll("input[type='submit'], button[type='submit']");
	for (var i = 0; i < submitButtons.length; ++i) {
		var submitButton = submitButtons[i];

		submitButton.addEventListener("click", function(event) {
			executeRecaptcha(event, form, recaptchaWidgetId);
		}, false);
	}


	// Označme formulář třídou, že už byla recaptcha inicializovaná.
	container.classList.add("recaptcha-initialized");

	// Přidejme na formulář ještě zresetování captchy po odeslaném požadavku.
	form.addEventListener("ajaxcompleted", function(event) {
		resetRecaptcha(event, form, recaptchaWidgetId);
	}, false);
}

//
// Aktivujme recaptchu
//
function activateRecaptcha(parentContainer) {
	if (!isRecaptchaLoaded) {
		// Recaptcha ještě není nahraná, nemáme tedy v tuto chvíli co dělat.
		return;
	}

	// Vyhledejme všechny formuláře, kde by měla být recaptcha.
	parentContainer = parentContainer || document;
	var recaptchaContainers = parentContainer.querySelectorAll("form [data-sitekey]:not(.recaptcha-initialized)");
	for (var i = 0; i < recaptchaContainers.length; ++i) {
		var recaptchaContainer = recaptchaContainers[i];
		var form = recaptchaContainer.closest("form");
		activateRecaptchaOnForm(form);
	}
}


//
// Inicializujme recaptchu
//
window.googleRecaptchaReady = function() {
	isRecaptchaLoaded = true;
	activateRecaptcha();
};


/* Následující kód aktivuje recaptchu po načtení stránky přímo na formuláři.

//
// Projděme nově vkládaný kód (reaguje i na Nette AJAX) a podívejme se,
// jestli je potřeba inicializovat recaptcha.
//
onContentReady(function(parent) {
	// Tato událost má jako volitelný parametr rodičovský element, ve kterém proběhla změna
	// (tj. buď jde o "body" v případě načtení dokumentu a nebo o kontejner snippetu).

	if (isRecaptchaLoaded) {
		// Recaptcha je již plně inicializovaná, aktivujme ji na nově přidaných formulářích.
		activateRecaptcha(parent);
		return;
	}
	else if (isRecatpchaRequested) {
		// Recaptcha je již vyžádaná, nemáme tedy nyní co dál dělat a musíme počkat na její inicializaci.
		// Jakmile se inicializuje, aktivace bude automaticky následovat.
		return;
	}

	// Vyhledejme v nově přidaném obsahu libovolný recaptchou zabezpečený formulář.
	var isRecaptchaFormExists = !!parent.querySelector("form .recaptcha-container");
	if (!isRecaptchaFormExists) {
		// Na této stránce není žádný formulář chráněný recaptchou.
		return;
	}

	// Inicializujme knihovny recaptchy.
	isRecatpchaRequested = true;
	ModuleLoader.push({ name: "GoogleRecaptcha", callbackName: "googleRecaptchaReady" });
});

*/

//
// Načtěme recaptchu až při použití formuláře.
//
document.addEventSelectorListener("focusin click input", "input, select, textarea, button", function(event, target) {
	var form = target.closest("form");
	if (!form) {
		// Element není součástí žádného formuláře.
		return;
	}

	var isRecaptchaExists = !!form.querySelector("[data-sitekey]:not(.recaptcha-initialized)");
	if (!isRecaptchaExists) {
		// Element není součástí recaptchou zabezpečeného formuláře a nebo je recaptcha už inicializovaná.
		return;
	}

	if (isRecaptchaLoaded) {
		// Recaptcha je již plně inicializovaná, aktivujme ji na tomto ještě nezabezpečeném formuláři.
		activateRecaptcha();
		return;
	}
	else if (isRecatpchaRequested) {
		// Recaptcha je již vyžádaná, nemáme tedy nyní co dál dělat a musíme počkat na její inicializaci.
		// Jakmile se inicializuje, aktivace bude automaticky následovat.
		return;
	}

	// Inicializujme knihovny recaptchy.
	isRecatpchaRequested = true;
	window.ModuleLoader.push({ name: "GoogleRecaptcha", callbackName: "googleRecaptchaReady" });
});
